import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import _ from 'lodash';
import { Tabs } from 'primeng/tabs';
import {
  EventType,
  ProgramTypesGUID
} from '../../../../../models/_enum-collections';
import { EventMilestone2Customer } from '../../../../../models/event-milestone-2-customer.model';
import { EventMilestone2PaymentDetails } from '../../../../../models/event-milestone-2-payment-details.model';
import { EventPaymentTierDetails } from '../../../../../models/event-payment-tier-details.model';
import { EventPayoutMetric } from '../../../../../models/event-payout-metric.model';
import { Milestone2InvoiceRequest } from '../../../../../models/milestone2-invoice-request.model';
import { Milestone2PaymentStatus } from '../../../../../models/milestone2-payment-status.model';
import { ProgramSharedService } from '../../../../common/program-shared.service';
import { CommonSharedModule } from '../../../../common/shared.module';
import { EventDashboardService } from '../../../../services/event-dashboard.service';

@Component({
  selector: 'app-event-milestone2-payment-information',
  templateUrl: './event-milestone2-payment-information.component.html',
  styleUrls: ['./event-milestone2-payment-information.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class AppEventsMilestone2PaymentInformationComponent implements OnInit {
  @Input() eventId!: number;
  @ViewChild(Tabs, { static: false }) tabView!: Tabs;
  eventsMilestone2Details!: EventMilestone2PaymentDetails;
  selectedCustomer!: EventMilestone2Customer;
  isReadonlyMilestone2Payment = true;
  msgsMilestone2InvoiceDetails!: any[];
  eventsMilestone2btnNav = false;
  formE3Maturity!: FormGroup;
  formE5Maturity!: FormGroup;
  formMRPPMilestone2!: FormGroup;
  showFormE3Maturity = false;
  showFormE5Maturity = false;
  showFormPaymentDetails = false;
  paymentStatus!: Milestone2PaymentStatus[];

  @Input() partnerMpnid!: number;
  @Input() programTypeGUID!: string;

  datePipe = new DatePipe('en-US');
  maxYearDate!: Date;

  hasMilestoneData = false;
  isMRPPProgram = false;
  months: any[] = [
    { label: 'Jan', value: 'Jan' },
    { label: 'Feb', value: 'Feb' },
    { label: 'Mar', value: 'Mar' },
    { label: 'Apr', value: 'Apr' },
    { label: 'May', value: 'May' },
    { label: 'Jun', value: 'Jun' },
    { label: 'Jul', value: 'Jul' },
    { label: 'Aug', value: 'Aug' },
    { label: 'Sep', value: 'Sep' },
    { label: 'Oct', value: 'Oct' },
    { label: 'Nov', value: 'Nov' },
    { label: 'Dec', value: 'Dec' }
  ];

  selectedMonth: any;
  payoutMetricOptions: any[] = [];
  selectedPayoutMetric: any;

  constructor(
    private eventsDashboard: EventDashboardService,
    private formBuilder: FormBuilder,
    public programSharedService: ProgramSharedService
  ) {}

  ngOnInit() {
    this.isMRPPProgram =
      this.programTypeGUID !== undefined &&
      this.programTypeGUID == ProgramTypesGUID.MRPP;
    this.getDesignationsAndPaymentStatus();
    this.getPayoutMetricOptions(this.eventId);
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formE3Maturity = this.formBuilder.group({
      eventPaymentRecordId: [''],
      eventType: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: ['']
    });
    this.formE5Maturity = this.formBuilder.group({
      eventPaymentRecordId: [''],
      eventType: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: ['']
    });

    this.formMRPPMilestone2 = this.formBuilder.group({
      eventPaymentRecordId: [''],
      paymentLineItemId: [''],
      eventType: [''],
      paymentAmount: [''],
      metDate: [''],
      paidDate: [''],
      paymentDocumentNumber: [''],
      invoiceNumber: [''],
      paymentStatus: [''],
      paymentCentralTransactionId: [''],
      maturityDate: [''],
      maturityStatus: [''],
      growthPerMAD: ['']
    });
  }

  getPayoutMetricOptions(eventId: number) {
    this.eventsDashboard
      .getEventsPayoutMetricOptions(eventId)
      .subscribe(options => {
        this.payoutMetricOptions = options.map(option => ({
          label: option.payoutMetric,
          value: option.payoutMetric
        }));
        if (!this.selectedPayoutMetric && this.payoutMetricOptions.length > 0) {
          this.selectedPayoutMetric = this.payoutMetricOptions[0];
        }
      });
  }

  getEventsMilestone2Details(eventId: number) {
    this.eventsDashboard
      .getEventsMilestone2PaymentDetails(eventId, this.programTypeGUID)
      .subscribe(milestone2PaymentDetails => {
        if (!milestone2PaymentDetails) {
          this.hasMilestoneData = false;
          return;
        }
        this.hasMilestoneData = true;
        this.eventsMilestone2Details = milestone2PaymentDetails;
        if (this.selectedCustomer == null) {
          this.selectedCustomer = this.eventsMilestone2Details.customers[0];
        } else {
          this.selectedCustomer = this.eventsMilestone2Details.customers.find(
            c => c.customerKey === this.selectedCustomer.customerKey
          ) as EventMilestone2Customer;
        }

        this.selectedMonth =
          this.selectedMonth == null ? this.months[0] : this.selectedMonth;

        this.selectedPayoutMetric =
          this.selectedPayoutMetric == null
            ? this.payoutMetricOptions[0]
            : this.selectedPayoutMetric;

        this.onFormGroup();

        if (!this.isMRPPProgram) {
          this.hasMilestoneData = true;
          const e3Metrics = this.selectedCustomer.payoutMetrics.find(
            p => p.payoutMetricName === 'NPSA E3'
          );
          const e5Metrics = this.selectedCustomer.payoutMetrics.find(
            p => p.payoutMetricName === 'NPSA E5'
          );
          if (e3Metrics != undefined) {
            this.showFormE3Maturity = true;
            this.formE3Maturity = this.buildPaymentForm(e3Metrics);
          }

          if (e5Metrics != undefined) {
            this.showFormE5Maturity = true;
            this.formE5Maturity = this.buildPaymentForm(e5Metrics);
          }
        } else {
          this.onPayoutMetricChange();
        }
      });
  }

  onPayoutMetricChange() {
    const selectedMetric = this.selectedCustomer.payoutMetrics.find(
      metric =>
        metric.payoutMetricName === this.selectedPayoutMetric.value &&
        metric.month === this.selectedMonth.value
    );
    if (selectedMetric) {
      this.showFormPaymentDetails = true;
      this.formMRPPMilestone2 = this.buildMRPPPaymentForm(selectedMetric);
    } else {
      this.showFormPaymentDetails = false;
    }
  }

  buildPaymentForm(milestonePayment: EventPayoutMetric) {
    const tier1Data = milestonePayment.tiers.find(t => t.tierName === 'Tier1');
    const tier2Data = milestonePayment.tiers.find(t => t.tierName === 'Tier2');
    const tier1MetFormattedDate =
      tier1Data?.dateTierMet == null
        ? ''
        : this.datePipe.transform(tier1Data.dateTierMet, 'MM/dd/yyyy');
    const tier2MetFormattedDate =
      tier2Data?.dateTierMet == null
        ? ''
        : this.datePipe.transform(tier2Data.dateTierMet, 'MM/dd/yyyy');

    const tier1MaturityFormattedDate =
      tier1Data?.maturityDate == null
        ? ''
        : this.datePipe.transform(tier1Data.maturityDate, 'MM/dd/yyyy');
    const tier2MaturityFormattedDate =
      tier2Data?.maturityDate == null
        ? ''
        : this.datePipe.transform(tier2Data.maturityDate, 'MM/dd/yyyy');

    const tier1PaidFormattedDate = this.datePipe.transform(
      tier1Data?.paidDate,
      'MM/dd/yyyy'
    );
    const tier2PaidFormattedDate = this.datePipe.transform(
      tier2Data?.paidDate,
      'MM/dd/yyyy'
    );

    return this.formBuilder.group({
      eventPaymentRecordId: milestonePayment.paymentRecordId,
      eventType: this.eventsMilestone2Details.eventName,
      tier1PaymentAmount: tier1Data?.paymentAmount,
      tier2PaymentAmount: tier2Data?.paymentAmount,

      tier1MetDate: tier1MetFormattedDate,
      tier2MetDate: tier2MetFormattedDate,

      tier1PaidDate: tier1PaidFormattedDate,
      tier2PaidDate: tier2PaidFormattedDate,

      tier1InvoiceNumber: tier1Data?.invoiceNumber,
      tier2InvoiceNumber: tier2Data?.invoiceNumber,

      tier1PaymentCentralTransactionId: tier1Data?.paymentCentralTransactionId,
      tier2PaymentCentralTransactionId: tier2Data?.paymentCentralTransactionId,

      tier1PaymentDocumentNumber: tier1Data?.paymentDocumentNumber,
      tier2PaymentDocumentNumber: tier2Data?.paymentDocumentNumber,

      tier1PaymentStatus: {
        paymentStatusId: tier1Data?.paymentStatus,
        paymentStatusName:
          tier1Data?.paymentStatus == null
            ? null
            : this.getPaymentStatusName(tier1Data.paymentStatus)
      },
      tier2PaymentStatus: {
        paymentStatusId: tier2Data?.paymentStatus,
        paymentStatusName:
          tier2Data?.paymentStatus == null
            ? null
            : this.getPaymentStatusName(tier2Data.paymentStatus)
      },

      tier1MaturityDate: tier1MaturityFormattedDate,
      tier2MaturityDate: tier2MaturityFormattedDate,

      tier1MaturityStatus: tier1Data?.maturityStatus,
      tier2MaturityStatus: tier2Data?.maturityStatus
    });
  }

  buildMRPPPaymentForm(milestonePayment: EventPayoutMetric) {
    const tier = milestonePayment.tiers[0];

    const metFormattedDate =
      tier.dateTierMet == null
        ? ''
        : this.datePipe.transform(tier.dateTierMet, 'MM/dd/yyyy');

    const maturityFormattedDate =
      tier.maturityDate == null
        ? ''
        : this.datePipe.transform(tier.maturityDate, 'MM/dd/yyyy');

    const paidFormattedDate =
      tier.paidDate == null
        ? ''
        : this.datePipe.transform(tier.paidDate, 'MM/dd/yyyy');

    const growthPerMAD =
      tier.growthIncrementalLicenses +
      '/' +
      tier.madPayout +
      (tier.growthIncrementalLicenses != tier.madPayout
        ? '\n' + tier.payout
        : '');

    return this.formBuilder.group({
      eventPaymentRecordId: milestonePayment.paymentRecordId,
      paymentLineItemId: milestonePayment.paymentLineItemId,
      eventType: this.eventsMilestone2Details.eventName,
      paymentAmount: tier.paymentAmount,
      metDate: metFormattedDate,
      paidDate: paidFormattedDate,
      invoiceNumber: tier.invoiceNumber,
      paymentCentralTransactionId: tier.paymentCentralTransactionId,
      paymentDocumentNumber: tier.paymentDocumentNumber,
      paymentStatus: {
        paymentStatusId: tier.paymentStatus,
        paymentStatusName:
          tier.paymentStatus == null
            ? null
            : this.getPaymentStatusName(tier.paymentStatus)
      },
      maturityDate: maturityFormattedDate,
      maturityStatus: tier.maturityStatus,
      growthPerMAD: growthPerMAD
    });
  }

  getDesignationsAndPaymentStatus() {
    this.eventsDashboard
      .getEventsMilestone2PaymentStatuses()
      .subscribe(paymentStatuses => {
        this.paymentStatus = paymentStatuses;
        this.getEventsMilestone2Details(this.eventId);
      });
  }

  onSubmiEventstMilestone2Data(
    formMilestone2Payment: FormGroup,
    payoutMetricName: string
  ) {
    let customerDetails: EventMilestone2Customer = {
      customerKey: this.selectedCustomer.customerKey
    } as EventMilestone2Customer;
    customerDetails = _.cloneDeep(this.selectedCustomer);

    const milestoneMetrics = {
      paymentRecordId:
        formMilestone2Payment.controls['eventPaymentRecordId'].value,
      payoutMetricName: payoutMetricName,
      eventTypeId: this.eventsMilestone2Details.eventTypeId,
      tiers: [] as any as EventPaymentTierDetails,
      paymentLineItemId: null
    };

    if (!this.isMRPPProgram) {
      const tier1Details = {
        tierName: 'Tier 1',
        invoiceNumber:
          formMilestone2Payment.controls['tier1InvoiceNumber'].value,
        paidDate:
          formMilestone2Payment.controls['tier1PaidDate'].value == null
            ? null
            : typeof formMilestone2Payment.controls['tier1PaidDate'].value ===
                'string'
              ? new Date(formMilestone2Payment.controls['tier1PaidDate'].value)
              : formMilestone2Payment.controls['tier1PaidDate'].value,
        paymentCentralTransactionId:
          formMilestone2Payment.controls['tier1PaymentCentralTransactionId']
            .value,
        paymentDocumentNumber:
          formMilestone2Payment.controls['tier1PaymentDocumentNumber'].value,
        paymentStatus:
          formMilestone2Payment.controls['tier1PaymentStatus'].value == null
            ? null
            : formMilestone2Payment.controls['tier1PaymentStatus'].value
                .paymentStatusId
      };

      const tier2Details = {
        tierName: 'Tier 2',
        invoiceNumber:
          formMilestone2Payment.controls['tier2InvoiceNumber'].value,
        paidDate:
          formMilestone2Payment.controls['tier2PaidDate'].value == null
            ? null
            : typeof formMilestone2Payment.controls['tier2PaidDate'].value ===
                'string'
              ? new Date(formMilestone2Payment.controls['tier2PaidDate'].value)
              : formMilestone2Payment.controls['tier2PaidDate'].value,
        paymentCentralTransactionId:
          formMilestone2Payment.controls['tier2PaymentCentralTransactionId']
            .value,
        paymentDocumentNumber:
          formMilestone2Payment.controls['tier2PaymentDocumentNumber'].value,
        paymentStatus:
          formMilestone2Payment.controls['tier2PaymentStatus'].value == null
            ? null
            : formMilestone2Payment.controls['tier2PaymentStatus'].value
                .paymentStatusId
      };
      milestoneMetrics.tiers = [tier1Details, tier2Details] as any;
      milestoneMetrics.paymentLineItemId = null;
    } else {
      const mrppDetails = {
        invoiceNumber: formMilestone2Payment.controls['invoiceNumber'].value,
        paidDate:
          formMilestone2Payment.controls['paidDate'].value == null
            ? null
            : typeof formMilestone2Payment.controls['paidDate'].value ===
                'string'
              ? new Date(formMilestone2Payment.controls['paidDate'].value)
              : formMilestone2Payment.controls['paidDate'].value,
        paymentCentralTransactionId:
          formMilestone2Payment.controls['paymentCentralTransactionId'].value,
        paymentDocumentNumber:
          formMilestone2Payment.controls['paymentDocumentNumber'].value,
        paymentStatus:
          formMilestone2Payment.controls['paymentStatus'].value == null
            ? null
            : formMilestone2Payment.controls['paymentStatus'].value
                .paymentStatusId
      };
      milestoneMetrics.tiers = [mrppDetails] as any;
      milestoneMetrics.paymentLineItemId =
        formMilestone2Payment.controls['paymentLineItemId'].value;

      const monthWiseMilestoneDate = this.selectedCustomer.payoutMetrics.find(
        p => p.month === this.selectedMonth.value
      );
      milestoneMetrics.payoutMetricName =
        monthWiseMilestoneDate?.payoutMetricName ?? payoutMetricName;
    }

    customerDetails.payoutMetrics = [milestoneMetrics] as any;

    const milestone2InvoiceRequest: Milestone2InvoiceRequest = {
      programTypeGuid: this.programTypeGUID,
      eventRegistrationId: this.eventId,
      milestone2Customer: customerDetails
    };

    this.eventsDashboard
      .updateEventsMilestone2Details(milestone2InvoiceRequest)
      .subscribe(
        messageResponse => {
          if (messageResponse === true) {
            this.msgsMilestone2InvoiceDetails = [];
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'success',
              detail: 'Milestone 2 Invoice Details Saved Successfully.'
            });
          } else {
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'error',
              detail:
                'Sorry an error occured while updating milestone 2 invoice details'
            });
          }

          this.editEventsMilestone2Cancel();
        },
        () => {
          this.msgsMilestone2InvoiceDetails.push({
            severity: 'error',
            detail:
              'Sorry an error occured while updating milestone 2 invoice details'
          });
          this.editEventsMilestone2Cancel();
        }
      );
  }

  editEventsMilestone2Cancel(clearEdit: FormGroup | boolean = false) {
    this.editEventsMilestone2Data(clearEdit);
    this.getEventsMilestone2Details(this.eventId);
  }

  editEventsMilestone2Data(clearEdit: FormGroup | boolean = false) {
    if (clearEdit) {
      this.isReadonlyMilestone2Payment = true;
      this.eventsMilestone2btnNav = false;
      this.msgsMilestone2InvoiceDetails = [];
    } else {
      this.isReadonlyMilestone2Payment = !this.isReadonlyMilestone2Payment;
      this.eventsMilestone2btnNav = !this.eventsMilestone2btnNav;
    }
    if (this.eventsMilestone2btnNav) {
      this.msgsMilestone2InvoiceDetails = [];
    }
  }

  paymentMetricsTabChange() {
    this.editEventsMilestone2Data(true);
  }

  getPaymentStatusName(paymentStatusId: number) {
    return (
      this.paymentStatus.find(p => p.paymentStatusId == paymentStatusId)
        ?.paymentStatusName || ''
    );
  }

  onCustomerChange() {
    if (!this.isMRPPProgram) {
      const e3Metrics = this.selectedCustomer.payoutMetrics.find(
        p => p.payoutMetricName === 'NPSA E3'
      );
      const e5Metrics = this.selectedCustomer.payoutMetrics.find(
        p => p.payoutMetricName === 'NPSA E5'
      );
      if (e3Metrics != undefined) {
        this.showFormE3Maturity = true;
        this.formE3Maturity = this.buildPaymentForm(e3Metrics);
      } else {
        this.showFormE3Maturity = false;
      }

      if (e5Metrics != undefined) {
        this.showFormE5Maturity = true;
        this.formE5Maturity = this.buildPaymentForm(e5Metrics);
      } else {
        this.showFormE5Maturity = false;
      }
    } else {
      this.onPayoutMetricChange();
    }
  }

  onMonthChange() {
    this.onPayoutMetricChange();
  }

  get EventType(): typeof EventType {
    return EventType;
  }
}
